/* Carrusel de opiniones (Inicio, 2026-10-23, pedido del usuario): las citas
   avanzan solas hacia la izquierda, en bucle continuo, y se pueden arrastrar
   con el dedo o la rueda en cualquier momento.

   Las tarjetas reales del HTML son el único contenido. Para que el bucle no
   tenga huecos se repiten (copias aria-hidden e inert: lectores de pantalla y
   teclado leen cada opinión una sola vez) hasta llenar el ancho, y el juego
   entero se duplica. El avance mueve el scroll de la fila (no un transform):
   así el deslizamiento táctil sigue siendo nativo. Al pasar la mitad, el
   scroll retrocede exactamente un juego y no se nota el salto.
   Velocidad fija en px/s, igual en cualquier pantalla. Se detiene con el
   cursor encima, con una tarjeta enfocada, mientras se toca (y unos segundos
   después) y con la pestaña oculta. Con movimiento reducido no se monta:
   queda la fila desplazable de siempre.
   Para sumar opiniones basta agregar otra .review-card en el HTML (y su
   texto en i18n.js): el carrusel se arma solo. */
(function () {
  'use strict';
  var wrap = document.querySelector('.opiniones-mapa .reviews-track-wrap');
  var track = wrap && wrap.querySelector('.reviews-track');
  if (!track) return;
  var reducido = matchMedia('(prefers-reduced-motion: reduce)');
  var VELOCIDAD = 34;      // px por segundo
  var ESPERA_TOQUE = 4000; // ms quieto tras soltar el dedo
  var originales = [].slice.call(track.querySelectorAll('.review-card'));
  var montado = false, ancho = 0, mitad = 0, pos = 0, previo = 0, raf = 0;
  var encima = false, tocando = false, retomar = 0, quietoHasta = 0;

  function copia(card) {
    var c = card.cloneNode(true);
    c.setAttribute('aria-hidden', 'true');
    c.inert = true;
    c.classList.add('review-card--copia');
    return c;
  }

  function desmontar() {
    track.querySelectorAll('.review-card--copia').forEach(function (c) { c.remove(); });
    wrap.classList.remove('is-carrusel');
    cancelAnimationFrame(raf); raf = 0;
    montado = false;
  }

  function montar() {
    if (reducido.matches || !wrap.clientWidth) { if (montado) desmontar(); return; }
    var w = wrap.clientWidth;
    if (montado && Math.abs(w - ancho) < 2) return;
    desmontar();
    ancho = w;
    wrap.classList.add('is-carrusel');
    // Un juego que cubra al menos el ancho visible…
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    var juego = originales.reduce(function (s, c) { return s + c.offsetWidth + gap; }, 0);
    var vueltas = Math.max(1, Math.ceil(w / Math.max(1, juego)));
    for (var v = 1; v < vueltas; v++) originales.forEach(function (c) { track.appendChild(copia(c)); });
    // …y duplicado entero para el bucle sin costura.
    var primera = [].slice.call(track.querySelectorAll('.review-card'));
    primera.forEach(function (c) { track.appendChild(copia(c)); });
    var todas = track.querySelectorAll('.review-card');
    mitad = todas[primera.length].offsetLeft - todas[0].offsetLeft;
    pos = track.scrollLeft;
    montado = true;
    previo = 0;
    raf = requestAnimationFrame(paso);
  }

  function paso(t) {
    raf = requestAnimationFrame(paso);
    var dt = previo ? Math.min(0.1, (t - previo) / 1000) : 0;
    previo = t;
    // Si alguien desplazó la fila (dedo, rueda), se sigue desde ahí.
    if (Math.abs(track.scrollLeft - pos) > 2) pos = track.scrollLeft;
    if (encima || tocando || document.hidden || t < quietoHasta || !mitad) return;
    pos += VELOCIDAD * dt;
    if (pos >= mitad) pos -= mitad;
    track.scrollLeft = pos;
  }

  wrap.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') encima = true; });
  wrap.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') encima = false; });
  wrap.addEventListener('focusin', function () { encima = true; });
  wrap.addEventListener('focusout', function () { encima = false; });
  track.addEventListener('touchstart', function () { tocando = true; clearTimeout(retomar); }, { passive: true });
  track.addEventListener('touchend', function () {
    clearTimeout(retomar);
    retomar = setTimeout(function () { tocando = false; }, ESPERA_TOQUE);
  }, { passive: true });
  // Rueda o trackpad: una pausa breve para no pelear con la mano.
  track.addEventListener('wheel', function () { quietoHasta = performance.now() + 1500; }, { passive: true });
  // Al volver a la izquierda del todo con la mano, se salta a la copia.
  track.addEventListener('scroll', function () {
    if (montado && mitad && track.scrollLeft < 1 && (tocando || performance.now() < quietoHasta)) {
      track.scrollLeft = pos = mitad;
    }
  }, { passive: true });

  var programado = 0;
  function programar() {
    if (programado) return;
    programado = requestAnimationFrame(function () { programado = 0; montar(); });
  }
  montar();
  window.addEventListener('resize', programar);
  document.addEventListener('i18n:change', function () { ancho = 0; programar(); });
  if (document.fonts) document.fonts.ready.then(function () { ancho = 0; programar(); });
  reducido.addEventListener('change', function () { ancho = 0; montar(); });
  window.addEventListener('pageshow', programar);
})();
